import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import courseReducer from "./courseReducer";
import uiReducer from "./uiReducer";

const isDevelopment = process.env.NODE_ENV === "development";

const store = configureStore({
  reducer: {
    auth: authReducer,
    course: courseReducer,
    ui: uiReducer,
  },
  devTools: isDevelopment,
});

export default store;
